import { aboutItem } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100/80 border border-secondary-200/60 text-secondary-700 text-xs font-semibold mb-4 whitespace-nowrap">
            <i className="ri-information-line text-sm"></i>
            关于我们
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">{aboutItem.title}</h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            {aboutItem.sections.map((section, index) => (
              <div key={index} className="bg-background-50 rounded-lg border border-background-200/70 p-6">
                <h3 className="text-lg font-bold text-foreground-900 mb-3">{section.subtitle}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{section.content}</p>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap justify-center gap-8 md:gap-16 py-8 border-t border-background-200/70">
            {aboutItem.stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl md:text-4xl font-heading text-primary-500">{stat.value}</div>
                <div className="text-sm text-foreground-500 mt-2">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}